import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ConexionesService } from '../../services/conexiones.service'


interface Secretaria {
  nombre: string;
  titular: string;
  direcciones: string[];
  collapsed: boolean;
  hidden: boolean;
}

@Component({
  selector: 'app-varios',
  templateUrl: './varios.component.html',
  styleUrls: ['./varios.component.css']
})
export class VariosComponent implements OnInit {
  id:any;
  indicator: any;

  folio: any;
  estado: any
  bandera = false;
  motivo=""
  tipo: any;


  prescolar = false;
  primaria = false; 
  secundaria = false;

  searchTerm: string = '';
  secretarias: Secretaria[] = [];

  dependenciasAbiertas: boolean[] = new Array(100).fill(false);

  
  dependencias: any[] = [];
  dependenciasFiltradas: any[] = [];
  private estructura: { [key: string]: { titular: string; direcciones: string[] } } = {
    "Oficina de la Presidenta": {
      titular: "LIC. ROLANDO MARTÍN GUEVARA GONZÁLEZ", // Agregar titular aquí
      direcciones: [
        "Secretaría Técnica",
        "Secretaría Particular",
        "Dirección de Protocolo, Logística y Gestión de Eventos",
        "Dirección de Comunicación Social e Imagen Institucional",
        "Dirección de Relaciones Públicas",
        "Dirección de Atención Ciudadana",
        "Dirección de Atención Ciudadana",
        "Coordinación General de Institutos",
        "Coordinación General de Gestión Ambiental",
        "Dirección de Bienestar Animal",
       
      ]
    }, "Secretaría del Ayuntamiento": {
      titular: "LIC. ERNESTO FERRARA THERIOT", // Agregar titular aquí
      direcciones: [
        "Dirección Jurídica",
        "Dirección Municipal de Enlace con la S.R.E.",
        "Dirección de Protección Civil y Bomberos",
        "Dirección del Archivo Histórico Municipal",
        "Dirección de Vinculación Social",
        
      ]
    },
    "Secretaría de Tesorería y Finanzas": {
      titular: "C.P. ENRIQUE ÁLVAREZ DEL CASTILLO ROJAS", // Agregar titular aquí
      direcciones: [
        "Dirección de Egresos y Contabilidad",
        "Dirección de Ingresos",
        "Dirección de Ejecución Fiscal",
        "Dirección de Patrimonio",
        "Dirección de Catástro",
        "Dirección de Fondos y Control Presupuestal",
        "Dirección de Comercio, Alcoholes y Espectáculos Públicos"
      ]
    },
    "Secretaría de la Contraloría y Transparencia": {
      titular: "LIC. MA. REYNALDA PERALES RODRÍGUEZ", // Agregar titular aquí
      direcciones: [
        "Dirección de Asuntos Internos",
        "Dirección de Auditoría de Gasto Público e Ingresos",
        "Dirección de Auditoría de Organismos Descentralizados e Institutos",
        "Dirección de Auditoría de Obras y Servicios Públicos",
        "Dirección de Transparencia y Acceso a la Información"
      ]
    },
    "Secretaría de Administración": {
      titular: "LIC. MARLA ISABEL MONTANTES GONZÁLEZ", // Agregar titular aquí
      direcciones: [
        "Dirección de Recursos Humanos",
        "Dirección de Tecnologías de la Información y la Comunicación",
        "Dirección de Adquisiciones",
        "Dirección de Calidad, Evaluación de Procesos y Control Interno",
        "Dirección de Planeación Estratégica"
      ]
    },
    "Secretaría de Bienestar Social": {
      titular: "DRA. LILIANA MARGARITA ARJONA BAROCIO", // Agregar titular aquí
      direcciones: [
        "Dirección de Programas Federales",
        "Dirección de Bienestar Social",
        "Dirección del Zoológico y Acuario de Nuevo Laredo",
        "Dirección de Participación Social y Ciudadana",
        "Dirección de Salud Municipal"
      ]
    },
    "Secretaría de Obras Públicas y Desarrollo Urbano": {
      titular: "C. CARLOS G. DE ANDA HERNÁNDEZ", // Agregar titular aquí
      direcciones: [
        "Dirección de Proyectos",
        "Dirección de Obras Públicas",
        "Dirección de Desarrollo Urbano",
        "Dirección del Centro Histórico y Monumentos Patrimoniales"
      ]
    },
    "Secretaría de Educación, Cultura y Deporte": {
      titular: "LIC. JUAN ÁNGEL MARTÍNEZ SALAZAR", // Agregar titular aquí
      direcciones: [
        "Dirección de Educación",
        "Dirección de Arte y Cultura",
        "Dirección de Cultura Física y Deporte"
      ]
    },
    "Secretaría de Servicios Públicos Primarios": {
      titular: "ING. EVEN ARREDONDO BRAVO", // Agregar titular aquí
      direcciones: [
        "Dirección Administrativa",
        "Dirección de Alumbrado Público y Uso Eficiente de Energía Eléctrica",
        "Dirección de Conservación y Mantenimiento de Infraestructura Pública",
        "Dirección de Imagen y Embellecimiento a Espacios Municipales",
        "Dirección de Mantenimiento de Edificios Municipales",
        "Dirección de Mantenimiento Urbano",
        "Dirección de Parques y Jardines"
      ]
    },
    "Secretaría de Desarrollo Económico": {
      titular: "ARQ. LORENA GUADALUPE CAVAZOS MUÑOZ", // Agregar titular aquí
      direcciones: [
        "Dirección de Desarrollo Industrial y Comercio Exterior",
        "Dirección de Turismo",
        "Dirección de Comercio, Empleo y Pymes",
        "Dirección de Desarrollo Rural",
        "Dirección de Innovación Socioeconómica y Tecnológica"
      ]
    },
    "Secretaría de Seguridad Pública y Vialidad": {
      titular: "", // Agregar titular aquí
      direcciones: [
        "Dirección de Seguridad Pública",
        "Dirección de Tránsito y Vialidad"
      ]
    },

  /*  "Coordinación General de Gestión Ambiental": {
      titular: "LIC. TANIA TABOADA BLANCO", // Agregar titular aquí
      direcciones: [
        "Coordinación General de Gestión Ambiental"
      ]
    },
    "Coordinación General de Institutos": {
      titular: "MTRA. IMELDA MANGÍN TORRE", // Agregar titular aquí
      direcciones: [
        "Coordinación General de Institutos"
      ]
    },*/
   
   
   
   
   
   
   
  };
  constructor
  (
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,private db: ConexionesService
  ) { }

  ngOnInit(): void 
  {
    window.scroll(0, 300);

    this.id = this.route.snapshot.queryParams.id;
    console.log(this.id)


    if(this.id=='consulta'){
     // this.getBecas();
    }else{
      this.getConsulta();
    }
    this.loadSecretarias();
    this.cargarDependencias();
    
  }
  loadSecretarias(): void {
    this.secretarias = Object.keys(this.estructura).map(nombre => ({
      nombre: nombre,
      titular: this.estructura[nombre].titular,
      direcciones: this.estructura[nombre].direcciones,
      collapsed: false,
      hidden: false
    }));
  }

  toggleSecretaria(secretaria: Secretaria): void {
    secretaria.collapsed = !secretaria.collapsed;
  }

  onSearch(): void {
    const term = this.searchTerm.toLowerCase().trim();

    if (!term) {
      this.secretarias.forEach(sec => {
        sec.hidden = false;
      });
      return;
    }

    this.secretarias.forEach(sec => {
      const matchSecretaria = sec.nombre.toLowerCase().includes(term);
      const matchDireccion = sec.direcciones.some(dir =>
        dir.toLowerCase().includes(term)
      );

      if (matchSecretaria || matchDireccion) {
        sec.hidden = false;
        sec.collapsed = false;
      } else {
        sec.hidden = true;
      }
    });
  }

  highlightDireccion(direccion: string): boolean {
    if (!this.searchTerm) return false;
    return direccion.toLowerCase().includes(this.searchTerm.toLowerCase());
  }

  getDireccionLabel(count: number): string {
    return count === 1 ? 'dirección' : 'direcciones';
  }
  onKeydownEvent() {

    this.bandera = false;
  }

  enviarFolio() {
    this.motivo = '';
    this.estado = "";
    this.bandera = false;

   
        
    this.db.getClave2025(this.folio).then((data: any) => {
            this.primaria = false;
            this.prescolar = false;    
            this.secundaria = false;
          console.log(data)
            if(data.length>=1){
              this.bandera = true;
              console.log(data)

              let contienePrescolar = data[0].clave.includes("JN")
              let contienePrimaria = data[0].clave.includes("PR")
              let contieneSec = data[0].clave.includes("ES")
              let contieneSec2 = data[0].clave.includes("ST")


              if (contienePrescolar == true) {
                this.prescolar = true;
              }

              if (contienePrimaria == true) {
                this.primaria = true;
              }

              if (contieneSec == true) {
                this.secundaria = true;
              }
              if (contieneSec2 == true) {
                this.secundaria = true;
              }
             
              
             /* if(data[0].estado=="NO AUTORIZADO"){
                this.motivo = "No aplica";
                this.estado = "No aplica";
              }*/
            }else{
              this.estado ="no encontrado";
              this.motivo = "No se encontró la clave";
            }
            
             
          
  
          })
       
 

    //  }




  }
  enviarFolio2() {
    this.motivo = '';
    this.estado = "";
    this.bandera = false;

    let resultado = Number(this.folio); // 

    this.db.getClave2025_maestros(resultado).then((data: any) => {
         this.motivo = "";
         this.estado=""
        this.bandera = true;
      
      if (data.length >= 1) {
        if (data[0].comentarios){
        
            this.motivo = data[0].comentarios;
            this.estado = "NO AUTORIZADO";
        }else{
          this.motivo = "";
          this.estado = "AUTORIZADO";
        }
      
       
      }
      console.log(data)



    })



    //  }




  }

  getConsulta() {
    const url = "https://nld.gob.mx/php/indicadoresDesempeno.php";
    
    this.http.get<any>(url).subscribe(
      (response: any) => {
        this.indicator = response
      },
      (error: any) => {
        this.indicator = {}
      }
    )
  }
  
  cargarDependencias() {
    this.dependencias = [
     
      
      {
        nombre: 'OFICINA DE LA PRESIDENTA',
        icono: 'bi bi-person-badge',
        abierto: true,
        contactos: [
          { cargo: 'Recepción Oficina de la Presidenta', extension: 'Ext. 3535' },
           { cargo: 'Administrativo de la Coordinación de Información de la Oficina de la Presidenta', extension: 'Ext. 3467' },
          { cargo: 'Administrativo de la Oficina de la Presidenta', extension: 'Ext. 3618' },
          { cargo: 'Coordinación Administrativa de la Oficina de la Presidenta', extension: 'Ext. 3745' },
          { cargo: 'Área de Compromisos de la Oficina de la Presidenta', extension: 'Ext. 3619' },
        /*  { cargo: 'Jefe de la Oficina de la Presidenta', extension: 'Ext. 3625' },*/
         
        ]
      },
      {
        nombre: 'SÍNDICOS Y REGIDORES',
        icono: 'bi bi-people-fill',
        abierto: true,
        contactos: [
          { cargo: 'Recepción General', extension: 'Ext. 3525' },
          { cargo: 'Recepción de Síndicos', extension: 'Ext. 3528' },
          { cargo: '1er Síndico | Lic. Jesús Alberto Jasso Montemayor', extension: 'Ext. 3528' },
          { cargo: '2do Síndico | María Mirna Rendon Santos', extension: 'Ext. 3528' },
          { cargo: '1er Regidor | Sergio Fernando Pérez Villareal', extension: 'Ext. 3529' },
          { cargo: '2do Regidor | Samantha Khiabett Rodríguez Cantú', extension: 'Ext. 3702' },
          { cargo: '3er Regidor | Juan De Dios Juanes Carrizalez', extension: 'Ext. 3704' },
          { cargo: '4to Regidor | Imayra Iveth Inocencio González', extension: 'Ext. 3703' },
          { cargo: '5to Regidor | Guadalupe Zapata Muñiz', extension: 'Ext. 3705' },
          { cargo: '6to Regidor | Cristabell Zamora Cabrera', extension: 'Ext. 3706' },
          { cargo: '7o Regidor | Enrique Figueroa Rocha', extension: 'Ext. 3707' },
          { cargo: '8vo Regidor | Melissa Lizette Riestra Martínez', extension: 'Ext. 3709' },
          { cargo: '9o Regidor | Santos Francisco Hernández Aguilar', extension: 'Ext. 3712' },
          { cargo: '10o Regidor | Macarena Corazón González Nuñez', extension: 'Ext. 3701' },
          { cargo: '11er Regidor | José Hemin Pascacio Rodríguez', extension: 'Ext. 3714' },
          { cargo: '12do Regidor | Alma Margarita Sánchez Lerma', extension: 'Ext. 3717' },
          { cargo: '13er Regidor | Gabriel Alberto Solorzano Pérez', extension: 'Ext. 3718' },
          { cargo: '14to Regidor | Leticia Yasmin Meneses Camino', extension: 'Ext. 3721' },
          { cargo: '15to Regidor | Feliz Fernando García Aguilar', extension: 'Ext. 3708' },
          { cargo: '16to Regidor | Leticia Judith Barrera Garza', extension: 'Ext. 3710' },
          { cargo: '17o Regidor | Oscar José Treviño Carmona', extension: 'Ext. 3716' },
          { cargo: '18vo Regidor | Delia Cortes Benavides', extension: 'Ext. 3719' },
          { cargo: '19o Regidor | Edgardo Pedraza Quintanilla', extension: 'Ext. 3700' },
          { cargo: '20o Regidor | Alma Rosa Castaño Rodríguez', extension: 'Ext. 3723' },
          { cargo: '21er Regidor | Gamaliel Alberto Infante Ramírez', extension: 'Ext. 3720' }
        ]
      },
      {
        nombre: 'JEFE DE LA OFICINA DE LA PRESIDENTA',
        icono: 'bi bi-person-badge',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: 'Ext. 3535' },
        ]
      },
      {
        nombre: 'DIRECCIÓN DE ATENCIÓN CIUDADANA',
        icono: 'bi bi-building',
        abierto: true,
        contactos: [
          { cargo: 'Conmutador Principal', extension: 'Ext. 3500' },
          { cargo: 'Coordinación DEL CIGA 1', extension: 'Ext. 3522' },
          
          { cargo: 'Coordinación del CIGA 2', extension: 'Ext. 3643' },
          { cargo: 'Recepción CIGA', extension: 'Ext. 3513' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE RELACIONES PÚBLICAS',
        icono: 'bi bi-chat-dots',
        abierto: true,
        contactos: [
          { cargo: 'Coordinación de Eventos', extension: 'Ext. 3504' },
          { cargo: 'Jefatura de Base de Datos', extension: 'Ext. 3421' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE LOGÍSTICA',
        icono: 'bi bi-truck',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Logística', extension: 'Ext. 3697' },
          { cargo: 'Coordinación Operativa', extension: 'Ext. 3738' },
          { cargo: 'Coordinación de Logística Operativa', extension: '867-7108646' },
          { cargo: 'Jefatura de Análisis de Información', extension: 'Ext. 3730' },
          { cargo: 'Jefatura de Administración', extension: 'Ext. 3615' },
          { cargo: 'Recepción', extension: 'Ext. 3617' },
          { cargo: 'Recepción del Director', extension: 'Ext. 3515' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE COMUNICACIÓN SOCIAL E IMAGEN INSTITUCIONAL',
        icono: 'bi bi-megaphone',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Comunicación Social e Imagen Institucional', extension: 'Ext. 3565' },
          { cargo: 'Coordinación de Comunicación social e Imagen Institucional', extension: 'Ext. 3596' },
          { cargo: 'Jefatura de Monitoreo', extension: 'Ext. 3514' },
          { cargo: 'Área de Streaming', extension: 'Ext. 3429' },
          { cargo: 'Área de Pauteo', extension: 'Ext. 3413' },
          { cargo: 'Editor de contenido', extension: 'Ext. 3459' },
          { cargo: 'Recepción del Director', extension: 'Ext. 3602' },
          { cargo: 'Secretaria del coordinador', extension: 'Ext. 3594' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE PLANEACIÓN ESTRATÉGICA',
        icono: 'bi bi-graph-up-arrow',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Planeación Estratégica', extension: '867-7125177' },
          { cargo: 'Coordinación de Fortalecimiento Institucional', extension: 'Ext. 3440 / 3563' },
          { cargo: 'Jefatura de Fortalecimiento Institucional', extension: 'Ext. 3568' },
          { cargo: 'Recepción', extension: 'Ext. 3580' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE SALUD MUNICIPAL',
        icono: 'bi bi-heart-pulse',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Salud Municipal', extension: '867-7113537' },
          { cargo: 'Coord. de Jubilados y Pensionados', extension: 'Ext. 3485' },
          { cargo: 'Recepción Pensionados y Jubilados', extension: 'Ext. 3635' },
          { cargo: 'Farmacia UNE', extension: '8677134778' }
        ]
      },
      {
        nombre: 'SECRETARÍA DE AYUNTAMIENTO',
        icono: 'bi bi-bank',
        abierto: true,
        contactos: [
          { cargo: 'Secretaría del Ayuntamiento', extension: 'Ext. 3531' },
          { cargo: 'Recepción', extension: 'Ext. 3558' },
          { cargo: 'Coordinación Administrativa de la Secretaría del Ayuntamiento', extension: 'Ext. 3432' },
          { cargo: 'Recepción', extension: 'Ext. 3531' },
          { cargo: 'Jurídico', extension: 'Ext. 3436 / 3544 / 3477' },
          { cargo: 'Dir Jurídico', extension: 'Ext. 3488' }
        ]
      },
      {
        nombre: 'AYUNTAMIENTO',
        icono: 'bi bi-building',
        abierto: true,
        contactos: [
          { cargo: 'Coordinación de la Junta Municipal de Reclutamiento', extension: '867-7123337' },
          { cargo: 'Coordinación de la Junta Municipal de Reclutamiento', extension: '867-7125998' }
        ]
      },
      {
        nombre: 'PROTECCIÓN CIVIL Y BOMBEROS',
        icono: 'bi bi-shield-check',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: '867-7124635' },
          { cargo: 'Administrativo', extension: '867-7123985' },
          { cargo: 'Emergencia', extension: '867-7128911' },
          { cargo: 'Emergencia', extension: '867-7122124' },
          { cargo: 'Emergencia', extension: '867-7123030' }
        ]
      },
      {
        nombre: 'DIRECCIÓN JURÍDICA DEL R. AYUNTAMIENTO',
        icono: 'bi bi-scale',
        abierto: true,
        contactos: [
          { cargo: 'Director Jurídico del R. Ayuntamiento', extension: 'Ext. 3488' },
          { cargo: 'Coordinación General de Asuntos Jurídicos', extension: 'Ext. 3436' },
          { cargo: 'Coordinación de Juicios', extension: 'Ext. 3477' },
          { cargo: 'Asesores Jurídicos', extension: 'Ext. 3544' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE ARCHIVO HISTORICO',
        icono: 'bi bi-archive',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Archivo Histórico', extension: '867-7137228' },
          { cargo: 'Recepción', extension: '867-7137228' },
          { cargo: 'Coordinación General', extension: '867-7137229' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE COMERCIO, ALCOHOLES Y ESPECTÁCULOS PÚBLICOS',
        icono: 'bi bi-shop',
        abierto: true,
        contactos: [
          { cargo: 'Comercio Informal', extension: 'Ext. 3592' },
          { cargo: 'Recepción', extension: 'Ext. 3593' },
          { cargo: 'Espectáculos', extension: 'Ext. 3590' },
          { cargo: 'Espectáculos Caja', extension: 'Ext. 3546' }
        ]
      },
      {
        nombre: 'DIRECCIÓN MUNICIPAL DE ENLACE CON LA S.R.E.',
        icono: 'bi bi-globe',
        abierto: true,
        contactos: [
          { cargo: 'Dirección Municipal de Enlace con la S.R.E.', extension: 'Ext. 3538' },
          { cargo: 'Recepción del Director', extension: 'Ext. 3560' },
          { cargo: 'Entrega de Pasaportes', extension: '867-7113561' },
          { cargo: 'Jurídico', extension: 'Ext. 3647' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE ENTIDADES Y ORGANISMOS PARAMUNICIPALES',
        icono: 'bi bi-diagram-3',
        abierto: true,
        contactos: [
          { cargo: 'Coordinación General de Institutos', extension: 'Ext. 3634' }
        ]
      },
      {
        nombre: 'IMVISU',
        icono: 'bi bi-house-door',
        abierto: true,
        contactos: [
          { cargo: 'IMVISU', extension: 'Ext. 3845' },
          { cargo: 'Recepción de Dirección', extension: 'Ext. 3499' },
          { cargo: 'Escrituración', extension: 'Ext. 3691' },
          { cargo: 'Prospectación', extension: 'Ext. 3407' },
          { cargo: 'Contabilidad', extension: 'Ext. 3690' },
          { cargo: 'Recepción', extension: '867-7113503' },
          { cargo: 'Recepción del Director', extension: 'Ext. 3430' }
        ]
      },
      {
        nombre: 'INMUJER',
        icono: 'bi bi-gender-female',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: '867-7135281 / 867-7192160' },
          { cargo: 'Coordinación de Psicología', extension: 'Ext. 111' },
          { cargo: 'Coordinación Jurídica', extension: 'Ext. 111' },
          { cargo: 'Coordinación de Trabajo Social', extension: 'Ext. 107' },
          { cargo: 'Coordinación de Contabilidad', extension: 'Ext. 105' },
          { cargo: 'Coordinación de Difusión y Proyectos', extension: 'Ext. 104' },
          { cargo: 'Coordinación de Capacitación', extension: 'Ext. 102' },
          { cargo: 'Asesoría Legal', extension: 'Ext. 113/114' }
        ]
      },
      {
        nombre: 'IMJUVE',
        icono: 'bi bi-person-arms-up',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: '867-7137875' }
        ]
      },
      {
        nombre: 'ICCE',
        icono: 'bi bi-trophy',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: '867-7120525' }
        ]
      },
      {
        nombre: 'IMPACTA',
        icono: 'bi bi-lightning',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: '867-1963963' }
        ]
      },
      {
        nombre: 'IMPLADU',
        icono: 'bi bi-activity',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: '867-1860190' }
        ]
      },
      {
        nombre: 'SECRETARÍA DE TESORERÍA Y FINANZAS',
        icono: 'bi bi-cash-coin',
        abierto: true,
        contactos: [
          { cargo: 'Recepción del Secretario de Tesorería y Finanzas', extension: 'Ext. 3569' },
          { cargo: 'Jefatura Administrativa', extension: 'Ext. 3597' },
          { cargo: 'Recepción', extension: 'Ext. 3543' },
          { cargo: 'Coordinación Administrativa', extension: 'Ext. 3669 / 3801' },
          { cargo: 'Administrativo', extension: 'Ext. 3622 / 3681' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE EGRESOS',
        icono: 'bi bi-wallet2',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Egresos', extension: 'Ext. 3581' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE EJECUCIÓN FISCAL',
        icono: 'bi bi-clipboard-data',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Ejecución Fiscal', extension: 'Ext. 3480' },
          { cargo: 'Coordinación de Ejecución Fiscal', extension: 'Ext. 3780' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE PATRIMONIO',
        icono: 'bi bi-safe',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Patrimonio', extension: 'Ext. 3483' },
          { cargo: 'Coordinación de Bienes Muebles e Inmuebles', extension: 'Ext. 3475' },
          { cargo: 'Jefatura de Bienes Muebles', extension: 'Ext. 3497' },
          { cargo: 'Jefatura de Bienes Inmuebles', extension: 'Ext. 3806' },
          { cargo: 'Jefatura de Parque Vehicular', extension: 'Ext. 3437' },
          { cargo: 'Cuenta pública', extension: 'Ext. 3805' },
          { cargo: 'Recepción', extension: 'Ext. 3518' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE INGRESOS',
        icono: 'bi bi-currency-dollar',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Ingresos', extension: 'Ext. 3588' },
          { cargo: 'Coordinación de Ingresos Generales', extension: 'Ext. 3648/3457' },
          { cargo: 'Coordinación de Predial', extension: 'Ext. 3472' },
          { cargo: 'Predial', extension: 'Ext. 3502/3492/3456' },
          { cargo: 'Cajas', extension: 'Ext. 3542' },
          { cargo: 'Recepción', extension: 'Ext. 3567' },
          { cargo: 'Dirección de Catastro', extension: 'Ext. 3519' },
          { cargo: 'Jefatura de Estacionómetros', extension: 'Ext. 3590' },
          { cargo: 'Recepción Estacionómetros', extension: 'Ext. 3546' }
        ]
      },
      {
        nombre: 'SECRETARÍA DE CONTRALORÍA Y TRANSPARENCIA',
        icono: 'bi bi-eye',
        abierto: true,
        contactos: [
          { cargo: 'Secretaría de Contraloría y Transparencia', extension: 'Ext. 3501' },
          { cargo: 'Recepción', extension: 'Ext. 3626' },
          { cargo: 'Recepción 2', extension: 'Ext. 3631' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE AUDITORÍA Y GASTO PÚBLICO',
        icono: 'bi bi-file-earmark-check',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Auditoría y Gasto Público', extension: 'Ext. 3571' },
          { cargo: 'Auditoría Interna y Gasto Público', extension: 'Ext. 3402' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE TRANSPARENCIA Y ACCESO A LA INFORMACIÓN',
        icono: 'bi bi-unlock',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: 'Ext. 3577' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE AUDITORÍA DE OBRA',
        icono: 'bi bi-hammer',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Auditoría de Obra', extension: 'Ext. 3403' },
          { cargo: 'Recepción del Director de Auditoría de Obra Pública', extension: 'Ext. 3621' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE ASUNTOS INTERNOS',
        icono: 'bi bi-shield-exclamation',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Asuntos Internos', extension: 'Ext. 3494' },
          { cargo: 'Coordinación de Auditor Administrativa y Control interno', extension: 'Ext. 3404' },
          { cargo: 'Coordinación de Quejas y Atención Ciudadana para el Combate a la Corrupción', extension: 'Ext. 3620' }
        ]
      },
      {
        nombre: 'DIGA',
        icono: 'bi bi-megaphone',
        abierto: true,
        contactos: [
          { cargo: 'DIGA', extension: '867-7121037' }
        ]
      },
      {
        nombre: 'SECRETARÍA DE ADMINISTRACIÓN',
        icono: 'bi bi-gear',
        abierto: true,
        contactos: [
          { cargo: 'Secretaría de Administración', extension: 'Ext. 3401' },
          { cargo: 'Coordinación Administrativo', extension: 'Ext. 3579' },
          { cargo: 'Coordinación de Licitaciones y Concursos', extension: '867-7121291' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE RECURSOS HUMANOS',
        icono: 'bi bi-person-badge',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Recursos Humanos', extension: 'Ext. 3566' },
          { cargo: 'Coordinación de capacitación', extension: 'Ext. 3559' },
          { cargo: 'Coordinación de Personal', extension: 'Ext. 3468/3645' },
          { cargo: 'Gafetes', extension: 'Ext. 3605' },
          { cargo: 'Recepción', extension: 'Ext. 3517' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE NÓMINAS',
        icono: 'bi bi-card-list',
        abierto: true,
        contactos: [
          { cargo: 'Coordinación de Nóminas', extension: 'Ext. 3419' },
          { cargo: 'Jefatura de Nóminas', extension: 'Ext. 3452' },
          { cargo: 'Administrativo', extension: 'Ext. 3569' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE TECNOLOGIAS DE LA INFORMACIÓN Y LA COMUNICACIÓN',
        icono: 'bi bi-laptop',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Tecnologías de la Información y la Comunicación', extension: 'Ext. 3880' },
          { cargo: 'Coordinador de Soporte y Redes', extension: 'Ext. 3614' },
          { cargo: 'Soporte Técnico', extension: 'Ext. 3689/3688' },
          { cargo: 'Coordinación de Desarrollo de Sistemas', extension: 'Ext. 3725/3726' },
          { cargo: 'Site y Redes', extension: 'Ext. 3649' },
          { cargo: 'Administrativo', extension: 'Ext. 3711' },
          { cargo: 'Recepción', extension: 'Ext. 3556' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE ADQUISICIONES',
        icono: 'bi bi-cart',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Adquisiciones', extension: 'Ext. 3466' },
          { cargo: 'Recepción', extension: 'Ext. 3471' },
          { cargo: 'Coordinación de Mantenimiento Vehicular', extension: 'Ext. 3512' },
          { cargo: 'Coordinación de Compras', extension: 'Ext. 3420' },
          { cargo: 'Cotizaciones', extension: 'Ext. 3415' },
          { cargo: 'Cotizaciones', extension: 'Ext. 3418' },
          { cargo: 'Cotizaciones', extension: 'Ext. 3557' },
          { cargo: 'Cotizaciones', extension: 'Ext. 3612' },
          { cargo: 'Cotizaciones', extension: 'Ext. 3735' },
          { cargo: 'Cotizaciones', extension: 'Ext. 3740' },
          { cargo: 'Cotizaciones', extension: 'Ext. 3742' },
          { cargo: 'Contabilidad', extension: 'Ext. 3715' },
          { cargo: 'Padrón de Proveedores', extension: 'Ext. 3750' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE CALIDAD Y EVALUACIÓN DE PROCESOS',
        icono: 'bi bi-award',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Calidad y Evaluación de Procesos', extension: 'Ext. 3610' },
          { cargo: 'Coordinación Administrativa', extension: 'Ext. 3611' },
          { cargo: 'Coordinación de Mejora Continua', extension: 'Ext. 3439' },
          { cargo: 'Coordinación de MICI', extension: 'Ext. 3435' },
          { cargo: 'Auditores', extension: 'Ext. 3479' },
          { cargo: 'Recepción', extension: 'Ext. 3527' }
        ]
      },
      {
        nombre: 'SECRETARÍA DE OBRAS PÚBLICAS, DESARROLLO URBANO Y MEDIO AMBIENTE',
        icono: 'bi bi-cone-striped',
        abierto: true,
        contactos: [
          { cargo: 'Secretaría de Obras Públicas, Desarrollo Urbano y Medio Ambiente', extension: '867-7123020 / 867-7121005' },
          { cargo: 'Dirección Administrativo', extension: 'Ext. 112' },
          { cargo: 'Coordinación Técnica', extension: 'Ext. 123' },
          { cargo: 'Coordinación Jurídico', extension: 'Ext. 127' },
          { cargo: 'Coordinación de Desarrollo Urbano', extension: 'Ext. 136' },
          { cargo: 'Coordinación Administrativa', extension: 'Ext. 145' },
          { cargo: 'Coordinación de Infraestructura Vial', extension: 'Ext. 124' },
          { cargo: 'Coordinación de Recursos Humanos', extension: 'Ext. 139' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE OBRAS PÚBLICAS',
        icono: 'bi bi-building-gear',
        abierto: true,
        contactos: [
          { cargo: 'Director De Obras Publicas', extension: '867-7113650' },
          { cargo: 'Coordinación de Contratación', extension: 'Ext. 1028 / 1000' },
          { cargo: 'Coordinación de Programas Federales y Estatales', extension: 'Ext. 1018' },
          { cargo: 'Coordinación de Supervisión de Obras', extension: 'Ext. 1008 / 1015' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DEL CENTRO HISTORICO',
        icono: 'bi bi-bank2',
        abierto: true,
        contactos: [
          { cargo: 'Dirección del Centro Histórico', extension: '867-7135913' },
          { cargo: 'Coordinación De Proyectos', extension: '867-7135913' },
          { cargo: 'Coordinación de Restauración y Remodelación', extension: '867-7135913' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE MEDIO AMBIENTE Y CAMBIO CLIMÁTICO',
        icono: 'bi bi-tree',
        abierto: true,
        contactos: [
          { cargo: 'Dirección De Medio Ambiente y Cambio Climático', extension: '867-7147973' },
          { cargo: 'Coordinación de Desarrollo Urbano y Ordenamiento Ecológico Territorial', extension: '867-7147973' },
          { cargo: 'Coordinación Operativa', extension: '867-7147973' },
          { cargo: 'Coordinación Administrativa', extension: '867-7147973' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE TRÁNSITO Y VIALIDAD',
        icono: 'bi bi-traffic-light',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Tránsito y Vialidad', extension: '867-7113900' },
          { cargo: 'Dirección de Tránsito y Vialidad', extension: '867-7113902' }
        ]
      },
      {
        nombre: 'SECRETARÍA DE EDUCACIÓN, CULTURA Y DEPORTES',
        icono: 'bi bi-book',
        abierto: true,
        contactos: [
          { cargo: 'Secretaría de Educación, Cultura y Deportes', extension: 'Ext. 3598' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE EDUCACIÓN MUNICIPAL',
        icono: 'bi bi-journal-text',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Educación Municipal', extension: 'Ext. 3488' },
          { cargo: 'Coordinador de Fortalecimiento Educativo', extension: 'Ext. 3410' },
          { cargo: 'Coordinación Administrativa', extension: 'Ext. 3450' },
          { cargo: 'Coordinación de Educación Especial', extension: 'Ext. 3463' },
          { cargo: 'Jefatura de Becas a Primarias y Secundarias', extension: 'Ext. 3409' },
          { cargo: 'Jefatura de Transporte Escolar', extension: 'Ext. 3405' },
          { cargo: 'Recepción', extension: 'Ext. 3505' },
          { cargo: 'Fortalecimiento Educativo', extension: 'Ext. 3608' },
          { cargo: 'Apoyo Escolar', extension: 'Ext. 3491' },
          { cargo: 'Infraestructura', extension: 'Ext. 3462' },
          { cargo: 'Recepción de Dirección', extension: 'Ext. 3508' },
          { cargo: 'Coordinación Administrativa', extension: 'Ext. 3406' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE ARTE Y CULTURA',
        icono: 'bi bi-palette',
        abierto: true,
        contactos: [
          { cargo: 'Centro Cultural', extension: '867-7175959' },
          { cargo: 'Coordinación de la Compañía de Danza', extension: '867-7175958' },
          { cargo: 'Coordinación de Espacios Caravana Culturales', extension: '867-7175958' },
          { cargo: 'Coordinación del Centro Cultural', extension: '867-7175956' },
          { cargo: 'Coordinación de Casas de la Cultura', extension: '867-7363666 / 867-7153518' },
          { cargo: 'Coordinación de Bibliotecas', extension: '867-7173676' },
          { cargo: 'Jefatura de Teatros', extension: '867-7175953' },
          { cargo: 'Museos', extension: '867-7175960' },
          { cargo: 'Estación Palabra', extension: '867-7127844' },
          { cargo: 'Jefatura de Bibliotecas', extension: '867-7173427' },
          { cargo: 'Biblioteca Octavio Paz', extension: '867-7173417' },
          { cargo: 'Biblioteca Rubén Miranda', extension: '8677152197' },
          { cargo: 'Biblioteca Emiliano Zapata', extension: '867-7100030' },
          { cargo: 'Biblioteca José Vasconcelos', extension: '867-7131170' },
          { cargo: 'Biblioteca José María Martínez', extension: '867-7141415' },
          { cargo: 'Biblioteca Fidel Cuéllar', extension: '867-7130832' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE DEPORTES',
        icono: 'bi bi-bicycle',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Deportes', extension: '867-7154840' },
          { cargo: 'Coordinación Administrativa', extension: '867-7155293' },
          { cargo: 'Recepción', extension: '867-7194782' }
        ]
      },
      {
        nombre: 'SECRETARÍA DE BIENESTAR SOCIAL',
        icono: 'bi bi-heart',
        abierto: true,
        contactos: [
          { cargo: 'Secretaría de Bienestar Social', extension: '867-7133619 / 867-7186112' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE PROGRAMAS FEDERALES',
        icono: 'bi bi-flag',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Programas Federales', extension: '867-7186112' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE PARTICIPACIÓN CIUDADANA',
        icono: 'bi bi-people',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Participación ciudadana', extension: '867-7186112' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE BIENESTAR SOCIAL',
        icono: 'bi bi-house-heart',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Bienestar Social', extension: '867-7186112' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE ZOOLÓGICO',
        icono: 'bi bi-brightness-high',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Zoológico', extension: '867-7145423' }
        ]
      },
      {
        nombre: 'SECRETARÍA DE DESARROLLO ECONÓMICO',
        icono: 'bi bi-graph-up',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: '867-7120327 / 867-7123699 / 867-7136886' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE TURISMO',
        icono: 'bi bi-airplane',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: '867-7137020' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE DESARROLLO RURAL',
        icono: 'bi bi-tree-fill',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: '867-7136886' },
          { cargo: 'Rastro Municipal', extension: '867-7108137' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE COMERCIO, EMPLEO Y PYMES',
        icono: 'bi bi-briefcase',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: '867-7120327' },
          { cargo: 'Bolsa de Empleo', extension: '867-7137011' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE DESARROLLO INDUSTRIAL Y COMERCIO EXTERIOR',
        icono: 'bi bi-building-gear',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: '867-7134596 / 867-7134591' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE INNOVACIÓN SOCIOECONÓMICA Y TECNOLÓGICA',
        icono: 'bi bi-pc-display',
        abierto: true,
        contactos: [
          { cargo: 'Recepción', extension: '867-6884990' }
        ]
      },
      {
        nombre: 'SECRETARÍA DE SERVICIOS PÚBLICOS PRIMARIOS',
        icono: 'bi bi-tools',
        abierto: true,
        contactos: [
          { cargo: 'Secretaria de Servicios Públicos Primarios', extension: '867-712628' }
        ]
      },
      {
        nombre: 'DIRECCIÓN ADMINISTRATIVA',
        icono: 'bi bi-file-text',
        abierto: true,
        contactos: [
          { cargo: 'Dirección Administrativa', extension: '867-7126280' },
          { cargo: 'Coordinación de Calidad', extension: '867-7122242' }
        ]
      },
      {
        nombre: 'DIRECCIÓN OPERATIVA',
        icono: 'bi bi-gear-wide-connected',
        abierto: true,
        contactos: [
          { cargo: 'Dirección Operativa', extension: '867-7122033' },
          { cargo: 'Coordinación de Organismos Municipales', extension: '867-7126280 ext. 117' },
          { cargo: 'Coordinación de Alumbrado', extension: '867-7126280 ext. 120' },
          { cargo: 'Coordinación de Semaforización y Señalamiento', extension: '867-7125875' },
          { cargo: 'Coordinación de Conservación y mantenimiento', extension: '867-7122033 ext. 108' },
          { cargo: 'Coordinación de Inspección Urbana', extension: '867-7120242' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE MANTENIMIENTO DE EDIFICIOS PÚBLICOS',
        icono: 'bi bi-building-check',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Mantenimiento de Edificios Públicos', extension: '867-7108186' },
          { cargo: 'Coordinación de Logística Operativa', extension: '867-7108646' }
        ]
      },
      {
        nombre: 'DIRECCIÓN DE PARQUES Y JARDINES',
        icono: 'bi bi-flower1',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Parques y Jardines', extension: '867-7140073' },
          { cargo: 'Jefatura Supervisión', extension: '867-7140073' },
          { cargo: 'Jefatura del Vivero Municipal', extension: '867-7140073' },
          { cargo: 'Jefatura de Mantenimiento de Arroyo y Canales', extension: '867-7140073' }
        ]
      },
      {
        nombre: 'SISTEMA DIF MUNICIPAL',
        icono: 'bi bi-hospital',
        abierto: true,
        contactos: [
          { cargo: 'Sistema DIF Municipal', extension: '867-7121032 Ext. 107' },
          { cargo: 'Secretaria particular', extension: 'Ext. 105' }
        ]
      },
      {
        nombre: 'DIRECCIÓN GENERAL DIF',
        icono: 'bi bi-clipboard-plus',
        abierto: true,
        contactos: [
          { cargo: 'Dirección General', extension: '867-7121032 Ext.109' },
          { cargo: 'Finanzas', extension: 'Ext. 226' },
          { cargo: 'Contabilidad', extension: 'Ext. 106' },
          { cargo: 'Bienes', extension: 'Ext. 232' },
          { cargo: 'Jefe de Nóminas', extension: 'Ext. 124' },
          { cargo: 'Adquisiciones', extension: 'Ext. 227' },
          { cargo: 'Recursos Humanos', extension: 'Ext. 217' },
          { cargo: 'Comunicación', extension: 'Ext. 228' },
          { cargo: 'Programa Alimentario', extension: 'Ext. 290' },
          { cargo: 'Coordinación de Contabilidad', extension: 'Ext.223' },
          { cargo: 'Velatorio La Fe', extension: '867-7100054' },
          { cargo: 'Centro de Rehabilitación Integral', extension: '867-1504000' },
          { cargo: 'Centro de Autismo', extension: '867-1371512' },
          { cargo: 'CECUDI', extension: '867-7263500' },
          { cargo: 'Centro de Atención a Menores Fronterizos, CAMEF', extension: '867-7126976 / 867-2304361' },
          { cargo: 'Centro de atención a Mujeres', extension: '867-1151357' },
          { cargo: 'Unidad Especializada Contra la Violencia Intrafamiliar y de Género, UNEVIG', extension: '867-1152038 / 867-7133900' },
          { cargo: 'Guardería y Centro de Asistencia Infantil Comunitario, CAIC "Mi Angelito"', extension: '867-7130789 / 867-7149484' },
          { cargo: 'Guardería Especial del CRI', extension: '867-7107569' },
          { cargo: 'Guardería Mi Casa Dif', extension: '867-7263500 / 867-7130789' },
          { cargo: 'Guardería Lomas del Río', extension: '867-1158359' },
          { cargo: 'Guardería San Nicolas', extension: '867-7172446' },
          { cargo: 'Albergue "Semillas de Amor"', extension: '867-7120643' },
          { cargo: 'Casa Club del Adulto Activo', extension: '867-7175401 / 867-7175403' },
          { cargo: 'Asilo vida y Esperanza', extension: '867-7143857' },
          { cargo: 'Diurna "Reyna de la Paz"', extension: '867-7263355' },
          { cargo: 'Villas "Vida Plena"', extension: '867-7142544' },
          { cargo: 'Escuela de Música', extension: '867-7364000' }
        ]
      },
      {
        nombre: 'SECRETARÍA DE SEGURIDAD PÚBLICA Y VIALIDAD',
        icono: 'bi bi-shield-shaded',
        abierto: true,
        contactos: []
      },
      {
        nombre: 'DIRECCIÓN DE SEGURIDAD PÚBLICA',
        icono: 'bi bi-shield-fill-check',
        abierto: true,
        contactos: [
          { cargo: 'Dirección de Seguridad Pública', extension: '867-711-39-30' },
          { cargo: 'Coordinación administrativa', extension: 'Ext. 2231' },
          { cargo: 'Coordinación de la academia', extension: 'Ext. 2163' },
          { cargo: 'Recepción', extension: 'Ext. 2115' },
          { cargo: 'Jefatura de Recursos Materiales', extension: 'Ext. 2156' },
          { cargo: 'Jefatura Presupuestal', extension: 'Ext. 2126' },
          { cargo: 'Jefatura de Veladores (as)', extension: 'Ext. 2119' },
          { cargo: 'Informática', extension: 'Ext. 2159' },
          { cargo: 'Comunicación Social', extension: 'Ext. 2111' },
          { cargo: 'Dirección de Salud', extension: 'Ext. 3444' }
        ]
      }
    ];

    this.dependenciasFiltradas = [...this.dependencias];
  }

  toggleDependencia(index: number) {
    this.dependenciasFiltradas[index].abierto = !this.dependenciasFiltradas[index].abierto;
  }

  filtrarDependencias() {
    const term = this.searchTerm.toLowerCase().trim();

    if (!term) {
      this.dependenciasFiltradas = [...this.dependencias];
      return;
    }

    this.dependenciasFiltradas = this.dependencias
      .map(dep => {
        const contactosFiltrados = dep.contactos.filter((contacto: any) =>
          contacto.cargo.toLowerCase().includes(term) ||
          contacto.extension.toLowerCase().includes(term)
        );

        if (dep.nombre.toLowerCase().includes(term) || contactosFiltrados.length > 0) {
          return {
            ...dep,
            contactos: contactosFiltrados.length > 0 ? contactosFiltrados : dep.contactos,
            abierto: true
          };
        }
        return null;
      })
      .filter(dep => dep !== null);
  }

  limpiarBusqueda() {
    this.searchTerm = '';
    this.filtrarDependencias();
  }

}
 